module.exports = " <div class=menu _v-3ae5f01e=\"\"> <button class=\"btn btn-primary btn-blank btn-lg\" v-on:click=buttonDemoClick _v-3ae5f01e=\"\">{{buttonDemo}}</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3ae5f01e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Menu.vue
// module id = 22
// module chunks = 1